import { createContext } from 'react';
import { AIContextType } from '../types';

/**
 * Separado de AIProvider.tsx para que Fast Refresh de Vite funcione correctamente.
 * Un archivo que exporta tanto un Context (no-componente) como un Provider (componente)
 * es incompatible con Fast Refresh y provoca full page reloads.
 */
export const AIContext = createContext<AIContextType | null>(null);
